(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@hulu/design-tokens"), require("react"), require("styled-components"));
	else if(typeof define === 'function' && define.amd)
		define(["@hulu/design-tokens", "react", "styled-components"], factory);
	else if(typeof exports === 'object')
		exports["@hulu-react-style-components/typography"] = factory(require("@hulu/design-tokens"), require("react"), require("styled-components"));
	else
		root["@hulu-react-style-components/typography"] = factory(root[undefined], root["React"], root[undefined]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return 